import React, { Suspense, useCallback } from 'react';

import dynamic from 'next/dynamic';

import { Button, Text } from 'reaxl';

import Card from './Card';
import CardContentWithAnalytics from './CardContentWithAnalytics';
import { cardHeaders, cardImages } from './staticContent';

const CoverMyCarLimitedWarranty = dynamic(() => import(
    /* webpackChunkName: "CoverMyCarLimitedWarranty" */
    '@/components/vehicledetails/CoverMyCarLimitedWarranty'
), { ssr: false });

const warrantyType = 'Added Protection';
const programTitle = {
    30: '30-Day / 1000 Mile',
    60: '60-Day / 2000 Mile',
    90: '90-Day / 3000 Mile',
};

function SafeGuardCard({
    safeGuardProgram,
    setModalDetail,
    handleSeeDetailsClick = () => { },
    handleContentImpression = () => { },
    listingId,
    ...rest
}) {
    const handleSafeGuardModalClick = useCallback((event) => {
        handleSeeDetailsClick(event, { warrantyType });
        setModalDetail({
            title: 'Cover My Car Added Protection',
            isShow: true,
            content: (
                <Suspense fallback={null}>
                    <CoverMyCarLimitedWarranty
                        program={safeGuardProgram}
                        title={programTitle}
                        image={cardImages.SAFEGUARD}
                    />
                </Suspense>
            ),
            size: 'lg',
        });
    }, [handleSeeDetailsClick, setModalDetail, safeGuardProgram]);

    return (
        <Card
            id="safeguard"
            heading={cardHeaders.SAFEGUARD}
            image={cardImages.SAFEGUARD}
            showTile
            {...rest}
        >
            <CardContentWithAnalytics
                cardType={warrantyType}
                handleContentImpression={handleContentImpression}
                listingId={listingId}
            >
                <>
                    <Text componentClass="p">
                        Be prepared for the road ahead with additional
                        {' '}
                        {programTitle[safeGuardProgram]}
                        {' '}
                        protection included on this vehicle from the dealer.
                    </Text>

                    <Button
                        bsStyle="text-decorated"
                        onClick={handleSafeGuardModalClick}
                    >
                        View details
                    </Button>
                </>
            </CardContentWithAnalytics>
        </Card>
    );
}

export default SafeGuardCard;
